import React from 'react';
import PropTypes from 'prop-types';
import {
    injectIntl,
    intlShape
} from 'react-intl';

import css from './index.scss';
import listStyle from './dropdown-list.scss';
import messages from '../../messages';

import { worldIcon } from '../../../../helpers/icon-dictionary';
import { privacySettingSaveRequestEnum } from '../../../../helpers/enums';

import SvgIcon from '../../../svg-icon/svg-icon';
import DropDownList from '../../../dropdown-list';

const LanguageSettings = ({
    intl,
    getDefaultValue,
    preferences,
    onSelectHandler
}) => {
    /**
     * ENUMS
     */
    const {
        SCHOOL_COUNTRY,
        SCHOOL_LOCALE
    } = privacySettingSaveRequestEnum;

    /**
     * FUNCTIONS
     */
    const renderCountryDropdown = () => {
        const country = preferences.find(a => a.type === SCHOOL_COUNTRY);
        const countryOptions = country.availableOptions.map(item => ({
            key: item.value,
            value: item.text
        }));
        const defaultCountry = getDefaultValue(country, SCHOOL_COUNTRY);
        return (
            <div className={css.languageSettingsContainer__dropdown}>
                <DropDownList
                    css={listStyle}
                    name={SCHOOL_COUNTRY}
                    onChange={onSelectHandler}
                    options={countryOptions}
                    value={defaultCountry}
                />
            </div>
        );
    };

    const renderLanguageDropdown = () => {
        const locale = preferences.find(a => a.type === SCHOOL_LOCALE);
        const localeOptions = locale.availableOptions.map(item => ({
            key: item.value,
            value: item.text
        }));
        const defaultLocale = getDefaultValue(locale, SCHOOL_LOCALE);
        return (
            <div className={css.languageSettingsContainer__dropdown}>
                <DropDownList
                    css={listStyle}
                    name={SCHOOL_LOCALE}
                    onChange={onSelectHandler}
                    options={localeOptions}
                    value={defaultLocale}
                />
            </div>
        );
    };

    /**
     * RENDER
     */
    return (
        <div className={css.languageSettings}>
            <div className={css.languageSettings_header}>
                <div className={css.sectionIcon}><SvgIcon icon={worldIcon} /></div>
                <div className={css.sectionTitle}>{intl.formatMessage(messages.schoolLanguageSettings)}</div>
            </div>
            <div className={css.languageSettings_content}>
                <div className={css.languageSettingsContainer}>
                    <div className={css.languageSettingsContainer__box__half}>
                        <div className={css.languageSettingsContainer__title}>
                            <strong>{intl.formatMessage(messages.country)}</strong>
                        </div>
                        <div className={css.languageSettingsContainer__label}>
                            {intl.formatMessage(messages.countryDescripition)}
                        </div>
                        {renderCountryDropdown()}
                    </div>
                    <div className={css.languageSettingsContainer__box__half}>
                        <div className={css.languageSettingsContainer__title}>
                            <strong>{intl.formatMessage(messages.languageVariant)}</strong>
                        </div>
                        <div className={css.languageSettingsContainer__label}>
                            {intl.formatMessage(messages.languageVariantDescripition)}
                        </div>
                        {renderLanguageDropdown()}
                    </div>
                </div>
            </div>
        </div>
    );
};

LanguageSettings.propTypes = {
    /**
     * Manages the default values from dropdowns
     */
    getDefaultValue: PropTypes.func.isRequired,
    /**
     * Used to manage translations
     */
    intl: intlShape.isRequired,
    /**
     * Sets selected value to parent state property 'saveRequest'
     */
    onSelectHandler: PropTypes.func,
    /**
     * Returned value from init data call used to populate init values
     */
    preferences: PropTypes.array
};

export default injectIntl(LanguageSettings);



// WEBPACK FOOTER //
// ./app/components/privacy-settings/sub-components/language-settings/index.js